// test1652
(1652 && 0);
